<template>
  <div class="wjl-edit">
    <div :style="leftDivStyle" class="wjlEditRight" ref="wjlEditRight">
      <div class="question_title">
      <span>{{
        questionData.sectionName === undefined ? "" : questionData.sectionName
      }}</span>
        <span
        >({{
          questionData.sectionPrompt + "  本题" + questionData.score + "分。"
        }})</span
        >
      </div>
      <div class="paperQusetionContent">
        <div
          v-if="questionData.questionContent"
          class=" editorShowArea ql-editor title_one"
          v-html="questionData.questionContent"
        ></div>
        <div
          style="overflow: auto"
          class=" editorShowArea ql-editor"
          v-html="questionData.questionDto.questionContent"
        ></div>
      </div>
      <div v-if="isShowLeft" class="startBtn">
        <template v-if="isIt">
          <el-button v-if="openRight" v-bury="{ start: true }" @click="saveResults()" type="primary">保存答案</el-button>
          <el-button v-else v-bury="{ start: true }" @click="go_coder()" type="primary">开始答题</el-button>
        </template>
        <examinationBtn
          v-else
          :type="Number(productFlag)"
          :btnFlag="'examination'"
          :queryData="queryData"
          :questionData="questionData"
          @jumpStudy="jumpStudy"
        ></examinationBtn>
      </div>
    </div>
    <!-- 拖拽线 -->
    <div
      v-if="openRight"
      class="code_line"
      @mousedown.stop="lineMove($event)"
    >
          <span class="code_line_icon">
            <svg
              style="width: 20px; height: 13px"
              class="icon svg-icon"
              aria-hidden="true"
            >
              <use xlink:href="#icon-tuozhuai1"></use>
            </svg>
          </span>
    </div>
    <!-- 操作界面 -->
    <div :style="rightDivStyle" class="code_operation">
      <div class="programming_right_mask" v-show="isDrag"></div>
      <span
        v-if="openRight"
        title="收起"
        class="el-icon-arrow-right close_code_operation"
        @click="changeOpenRight"
      ></span>
      <!-- 编程工具封装 -->
      <it-env
        ref="itEnv"
        :show-tools-box="true"
        :platform-type="showRightType"
        :question-answer="questionAnswer"
        :iframe-src="iframeAddress"
        :question-id="questionData.questionId"
        :code-refresh="codeRefresh"
        v-model="taskData"
        @itEnvScore="resultScore"
      ></it-env>

    </div>

    <!--  // 根据试题id查询附件列表 -->
    <div class="questionEnclosure">
      <ul class="enclosureUl" v-show="enclosureUlShow">
        <li
          v-for="(item, index) in questionEnclosure"
          :key="index"
          class="questionEnclosureItem"
        >
          <span
            :title="item.name"
            @click="handlePreview(item.newAttaUrl)"
            class="enclosurePopoverLabel"
            >{{ item.name }}</span
          >
          <span
            class="el-icon-download enclosureDown"
            @click="handleImport(item.id)"
          ></span>
        </li>
      </ul>
      <div
        class="questionEnclosureStyle"
        v-show="questionEnclosure.length && !enclosureUlShow"
        @dblclick="dblclick"
        @click="openQuestionEnclosure"
      >
        <span class="el-icon-paperclip"></span>
        <span style="padding-right: 10px; padding-left: 3px">附件</span>
        <span class="number">{{ questionEnclosure.length }}</span>
      </div>
      <div v-show="questionEnclosure.length && enclosureUlShow" class="questionEnclosureStyle">
        <span></span>
        <span
          style="color: #d2d2d7"
          class="el-icon-close"
          @click="enclosureUlShow = false"
        ></span>
      </div>
    </div>

    <!-- 预览试题上的附件 -->
    <el-dialog
      :visible.sync="filePreviewDialog"
      destroy-on-close
      append-to-body
      width="80%"
      top="7%">
      <iframe
        style="width: 100%;"
        :style="{height: windowHeight/6*4 + 'px'}"
        :src="filePreviewUrl"
        frameborder="0"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
/**
 *
 *  测评中 实操题或组合题的题干、附件、跳转按钮
 */
import * as api from "../../../../../api/testExamApi";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import examinationBtn from "@/components/platformBtn/examination";
import * as couserApi from "../../../../../api/courseApi";
import qs from "qs";
import { isLinuxLabOS } from "@/utils/utils";
import * as courseApi from "@/api/courseApi"; // 目录树
import ItEnv from "@/views/szrt_revision/teachingDetail/list/classroom/itEnv";

export default {
  name: "operation",
  components: {
    examinationBtn,
    ItEnv
  },
  data() {
    return {
      windowHeight: window.innerHeight, // 窗口高度。
      template: {},
      productFlag: sessionStorage.getItem("productFlag"),
      queryData: null,
      //
      filePreviewUrl: "", // 预览附件
      filePreviewDialog: false, // 弹窗
      questionEnclosure: [],  // 根据试题id查询附件列表
      enclosureUlShow: false,
      //

      itType: ['codeBlockOS', 'jupyterNoteBook', 'liunxLabOS', 'jupyterTerminals', 'It_prefabrication','linuxLabOS'],
      iframeAddress: "", // IT工具
      showRightType: "",
      questionAnswer: "",
      taskData: "", // 获取编程题的作答记录
      itAnswer: '',
      leftWidth: "",
      openRight: false,
      isDrag: false,
      codeRefresh: 0, // 刷新
      leftDivStyle: {width: "100%"},
      rightDivStyle: {},
      //
      platform: '',
      isIt: false,
      templateCode: '',
      roleCode: '',

    };
  },
  computed: {
    ...mapState('exam', {
      questionData: (state) => state.questionData,
      paperData: (state) => state.paperData,
      isShowLeft: (state) => state.isShowLeft,
    }),
  },
  created() {
    this.queryData = this.$route.query;
    this.getAttachmentList();

    if (this.questionData && this.questionData.questionDto && this.questionData.questionDto.internalTypeId === 9){
      //根据试题ID 获取试题中所有事项的动态参数
      this.getAllparams(this.questionData.questionId);
    }

    console.log('-created-', this.$route.query, this.questionData)
  },
  watch: {
    questionData(val) {
      if (val) {
        this.changeOpenRight();
        this.getAttachmentList();
        if (val.questionDto && val.questionDto.internalTypeId === 9){
          //根据试题ID 获取试题中所有事项的动态参数
          this.getAllparams(val.questionId);
        }
      }
    }
  },
  methods: {
    ...mapMutations('exam', ['SHOW_OPTIONS', 'SET_IFRAME_URL', 'GET_SIGN', 'SHOW_BACK', 'SHOW_LEFT', 'SAVE_ANSWER_SUCCESS']),
    //根据试题ID 获取试题中所有事项的动态参数
    getAllparams(id) {
      courseApi.getQuestionDynmaicParam(id)
        .then((rs) => {
          if (rs.code === "0") {
            if (rs.data && rs.data[0] && rs.data[0].length) {
              [].forEach.call(rs.data[0], (item) => {
                if (item.param === "platform") {
                  this.platform = item.value;
                  this.isIt = this.itType.includes(item.value);
                }else if (item.param === "templateCode") {
                  this.templateCode = item.value
                }else if (item.param === "roles") {
                  this.roleCode = item.value
                }
              });
            } else {
              console.error('--getAllparams--', '未获取到跳转参数')
            }
          } else {
            this.$messageError(rs.msg);
          }
        })
        .catch(error => {
          console.error('--getAllparams--', error)
        });
    },

    /* 学习 作答 跳转 */
    jumpStudy(data, newObj) {
      this.SHOW_LEFT(false);
      this.SHOW_OPTIONS(true);
      this.SHOW_BACK(true);
      this.saveTest();
      let obj = {
        type: newObj.platform,
        url: data.iframeUrl,
      };
      this.SET_IFRAME_URL(obj);
    },
    dblclick() {},
    openQuestionEnclosure() {
      this.enclosureUlShow = true;
    },
    handlePreview(url) {
      if(process.env.NODE_ENV === 'native' || url.search("html") != -1){
        this.filePreviewUrl = url;
      }else{
        this.filePreviewUrl = process.env.PREVIEW_URL + url;
      }
      this.filePreviewDialog = true;
    },
    // 下载
    handleImport(val) {
      let url = `${process.env.UPLOAD_NAME}/file/downloadFiles?id=` + val;
      this.$downloadFun(url)
    },
    // 根据试题id查询附件列表
    getAttachmentList() {
      this.questionEnclosure = [];
      sessionStorage.setItem("questionEnclosure", "");
      couserApi
        .getAttachmentList({ questionId: this.questionData.questionId })
        .then((res) => {
          if (res.code == 0) {
            this.questionEnclosure = res.data;
            if (this.questionEnclosure.length) {
              sessionStorage.setItem(
                "questionEnclosure",
                JSON.stringify(this.questionEnclosure)
              );
            }
          }
        });
    },
    saveTest() {
      let obj = {
        examPaperId: this.paperData.examPaperId,
        // subjectId: localStorage.getItem("subjectId"),
        classId: this.$route.query.classId,
        className: this.$route.query.className,
        courseId: this.$route.query.id,
        paperCode: this.$route.query.paperCode,
        paperId: this.$route.query.paperId,
        questionId: this.questionData.questionId,
        questionType: 9,
        userAnswer: 1,
        score: this.questionData.score,
        questionStatus: 0,
        useTime: 1,
        version: "1",
        type: this.$route.query.type,
      };
      api.recordExam(obj).then((result) => {
        if (result.code === "0") {
          this.SAVE_ANSWER_SUCCESS({
            status: 1,
            questionId: this.questionData.questionId,
          });
        }
      });
    },

    // 关闭代码编辑模块
    changeOpenRight() {
      if (this.openRight) {
        this.leftDivStyle = {width: "100%"};
        this.rightDivStyle = {width: 0, opacity: 0};
      }
      this.openRight = false;
    },
    // 打开代码编辑模块
    changeCloseRight(){
      if (!this.openRight) {
        this.leftDivStyle = {width: this.leftWidth || '50%'};
        this.rightDivStyle = {flex: 1, opacity: 1, minWidth: '150px'};
      }
      this.openRight = true;
    },
    go_coder() {

      this.iframeAddress = "";

      if (this.platform === "codeBlockOS") {
        //代码块
        this.showRightType = "codeBlockOS";
        this.changeCloseRight();
      } else{
        //  编译器2
        this.showRightType = "";
        this.openCompilerOS(this.platform);
      }

    },

    // 打开编辑器
    openCompilerOS(to) {
      if (
        localStorage.getItem("Authorization") &&
        sessionStorage.getItem("userId")
      ) {

        console.log('--openCompilerOS--', this.$route.query)

        let productFlag = sessionStorage.getItem('productFlag'); //课程类型：1.课证融通、2.单项训练、3.综合实训、4.真实任务
        //  sourceId = examType_courseId_classId_examPlan_teamId_userId_courseType_setNumber;
        //  examType  2考试  3综合  4单项  5测验  6大赛  15课证融通测评
        //  courseId  课程id，没有写 NONE
        //  classId   班级id，没有写 NONE
        //  examPlan   计划id 或者 考试id  没有写 NONE
        //  teamId    小组id，  没有写 NONE  与userId互斥
        //  userId    用户id，  没有写 NONE  与teamId互斥
        //  courseType   课程类型   1课程 2实训
        //  setNumber   重置次数，默认1

        let examType = 'NONE';
        if (productFlag === '1'){
          if (this.$route.query.examType){  // 课程跳转过来，带了参数5
            examType = this.$route.query.examType
          } else{
            examType = 15
          }
        }else{
          examType = 5
        }
        let courseId = this.$route.query.id || 'NONE';
        let classId = this.$route.query.classId || 'NONE';
        let examPlan = this.$route.query.examId || 'NONE';
        let teamId = 'NONE';   // 测验里的测评没有小组，在综合实训中有。
        let userId = sessionStorage.getItem("userId");
        let courseType = 'NONE';
        let setNumber = 1;

        let sourceId = `${examType}_${courseId}_${classId}_${examPlan}_${teamId}_${userId}_${courseType}_${setNumber}`;

        let params = {
          edu_token: localStorage.getItem("Authorization"),
          userId: userId,
          sourceId: sourceId,
          questionId: this.questionData.questionId,
          templeteCode: this.templeteCode,
          paperCode: this.$route.query.paperCode,
          catalogId: "",
          roleCodes: this.roleCode,
        };
        if (to === "jupyterTerminals") {
          params["kernelType"] = "terminals";
          this.showRightType = "jupyterTerminals";
        }
        if (to === "jupyterNoteBook") {
          this.showRightType = "jupyterNoteBook";
        }
        if (isLinuxLabOS(to)) {
          this.showRightType = to;
          params["kernelType"] = "vnc";
          this.iframeAddress =
            process.env.VUE_APP_LINUXHUB +
            "/hub/login" +
            "?" +
            qs.stringify(params);
        } else {
          this.iframeAddress =
            process.env.VUE_APP_COS + "?" + qs.stringify(params);
        }

        this.changeCloseRight();
      } else {
        this.$messageError("账户信息未获取成功");
      }
    },

    //  编程题评分
    saveResults() {
       let params = {
          business: {
            "questionId": this.questionData.questionId,
            "userId": sessionStorage.getItem('userId'),
          },
          events: [],
          text: {
            "code": '',
            "output": ''
          }
        };

      if (this.platform === "codeBlockOS") {
        /* 暂未开发 */
      } else if (this.platform === "jupyterNoteBook" || isLinuxLabOS(this.platform)) {
       this.$refs.itEnv.exeScore(params)
      }
    },

    /** 轴挪动 */
    lineMove(ev) {
      let that = this;
      let screenX = ev.screenX;
      let refWidth = that.$refs.wjlEditRight.offsetWidth;
      that.isDrag = true;
      document.onmousemove = (e) => {
        window.event.preventDefault(); //
        window.event.cancelBubble = true; //IE
        let width = e.screenX - screenX + refWidth;
        that.$set(that.leftDivStyle, "width", width + "px");
        that.leftWidth = width + "px";
        that.$forceUpdate();
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        that.isDrag = false;
      };
    },
    /* 评分返回数据的处理 */
    resultScore(res) {
      let totalScore = [];
      if (
        res.data &&
        res.data.length
      ) {
        [].forEach.call(res.data, item => {
          if (item.formMapper) totalScore.push(item.stepWeight)
        })
      }
      let num = 0;
      totalScore.forEach(item => {
        num += Number(item)
      })
      this.saveTest(num * 5 / 100);
    },
  },
};
</script>

<style lang="scss" scoped>
.wjl-edit {
  max-width: 100%;
  background: #ffffff;
  height: 100%;
  display: flex;
  overflow: hidden;
  .wjlEditRight{
    position: relative;
  }
/* 附件样式 */
  .questionEnclosure {
    position: absolute;
    bottom: 25px;
    right: 70px;
    border-radius: 6px;
    box-shadow: 0px 0px 4px 0px rgba(24, 144, 255, 0.3);
    background: #ffffff;
    z-index: 10;

    .questionEnclosureStyle {
      color: #1890ff;
      height: 28px;
      padding: 0px 8px;
      display: flex;
      align-items: center;
      cursor: pointer;
      justify-content: space-between;

      .number {
        background: #1890ff;
        color: #ffffff;
        display: inline-block;
        height: 16px;
        width: 16px;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
        border-radius: 16px;
      }
    }

    .enclosureUl {
      max-height: 300px;
      overflow: auto;
    }

    .questionEnclosureItem {
      height: 36px;
      cursor: pointer;
      display: flex;
      align-items: center;
      position: relative;
      padding-left: 12px;
      padding-right: 40px;

      &:hover {
        background: rgba(24, 144, 255, 0.04);
        color: #1890ff;

        .enclosureDown {
          display: block;
        }
      }
    }

    .enclosurePopoverLabel {
      display: inline-block;
      width: 260px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      padding: 5px 0;
      font-size: 12px;
      color: #595964;
      vertical-align: -0.15em;
    }

    .enclosureDown {
      position: absolute;
      right: 12px;
      top: 7px;
      width: 24px;
      height: 24px;
      border-radius: 4px;
      font-size: 16px;
      text-align: center;
      line-height: 24px;
      display: none;

      &:hover {
        background: #1890ff;
        color: #ffffff;
      }
    }
  }

  .question_title {
    margin-left: 30px;
    padding-top: 30px;

    span:nth-child(1) {
      font-size: 18px;
      font-weight: bold;
    }

    span:nth-child(2) {
      font-size: 12px;
      font-weight: 500;
      margin-left: 12px;
    }
  }

  .paperQusetionContent {
    height: calc(100% - 115px);
    overflow: auto;
    z-index: 200;
    .title_one {
      border-bottom: 1px dashed black;
      width: 95%;
      margin: auto;
    }

    .ql-editor {
      max-width: 95%;
      overflow: auto !important;
      margin: auto;
    }

    /deep/ .ql-editor img {
      max-width: 100% !important;
    }
  }
/* 按钮 */
  .startBtn {
    position: absolute;
    bottom: 20px;
    left: 50%;
    z-index: 200;
    transform: translateX(-50%);

    button {
      width: 120px;
      height: 40px;
      line-height: 40px;
      padding: 0;
      background: linear-gradient(135deg, #1890ff 0%, #00b3f7 100%, #00b3f7 100%);
      border-radius: 24px;
      border: none;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      cursor: pointer;

      &:hover {
        background: linear-gradient(
            135deg,
            #1890ff 0%,
            #00b3f7 100%,
            #00b3f7 100%
        );
        border-radius: 24px;
        border: none;
        opacity: 0.8;
      }
    }
  }


  .code_line {
    width: 0px;
    height: 100%;
    position: relative;

    .code_line_icon {
      cursor: ew-resize;
      padding: 0px 8px;
      position: absolute;
      background: rgba(24, 144, 255, 0.2);
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(90deg);
      z-index: 3000;

      &:hover {
        background: rgba(24, 144, 255, 0.5);

        svg {
          fill: #ffffff;
        }
      }
    }

    svg {
      fill: #1890ff;
    }
  }
  .code_operation {
    height: calc(100% - 2px);
    width: 0px;
    opacity: 0;
    display: flex;
    flex-direction: column;
    box-shadow: -5px 0px 10px 0px rgba(183, 192, 199, 0.14);
    position: relative;
    /*overflow: hidden;*/


    .close_code_operation {
      cursor: pointer;
      position: absolute;
      background: rgba(24, 144, 255, 0.2);
      height: 30px;
      line-height: 30px;
      top: 0px;
      left: -15px;
      color: rgb(24, 144, 255);
      z-index: 3;
      border-radius: 6px 0 0 6px;

      &:hover {
        background: rgba(24, 144, 255, 0.5);
        color: #ffffff;
      }
    }

    .resetBtn {
      position: absolute;
      top: 0px;
      right: 0px;
      font-size: 12px;
      line-height: 28px;
      width: 60px;
      text-align: center;
      background: linear-gradient(
          135deg,
          #1890ff 0%,
          #00b3f7 100%,
          #00b3f7 100%
      );
      color: #ffffff;
      cursor: pointer;

      &:hover {
        opacity: 0.9;
      }
    }

    .programming_right_mask {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 20000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testComponent/operation.vue